/* Iskra – theme.js. Zero zależności, same Web Components. */
(() => {
  const T = window.theme || (window.theme = {});
  T.strings = T.strings || {};
  T.routes = T.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', root: '/' };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const designMode = () => !!(window.Shopify && window.Shopify.designMode);
  const sized = (src, w) => (src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '');
  const svg = d => `<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="${d}"/></svg>`;
  const ICON = { minus: svg('M5 12h14'), plus: svg('M12 5v14M5 12h14') };
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* tryb prywatny */ } }
  };

  /* ---------- pieniądze ---------- */
  T.formatMoney = (cents, format) => {
    cents = Math.round(Number(cents) || 0);
    if (T.currency && T.shopCurrency && T.currency !== T.shopCurrency) {
      try { return new Intl.NumberFormat(T.locale || undefined, { style: 'currency', currency: T.currency }).format(cents / 100); } catch (e) { /* dalej */ }
    }
    const fmt = String(format || T.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const n = (p, th, de) => {
      const parts = (cents / 100).toFixed(p).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (parts[1] ? de + parts[1] : '');
    };
    const map = {
      amount: () => n(2, ',', '.'),
      amount_no_decimals: () => n(0, ',', '.'),
      amount_with_comma_separator: () => n(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => n(0, '.', ','),
      amount_with_space_separator: () => n(2, ' ', ','),
      amount_no_decimals_with_space_separator: () => n(0, ' ', ','),
      amount_with_apostrophe_separator: () => n(2, "'", '.'),
      amount_with_period_and_space_separator: () => n(2, ' ', '.')
    };
    const m = fmt.match(re);
    return m ? fmt.replace(re, (map[m[1]] || map.amount)()) : fmt;
  };

  /* ---------- toast ---------- */
  T.toast = (msg, error) => {
    const t = $('[data-toast]');
    if (!t || !msg) return;
    t.textContent = msg;
    t.classList.toggle('toast--error', !!error);
    t.hidden = false;
    requestAnimationFrame(() => t.classList.add('is-visible'));
    clearTimeout(t._timer);
    t._timer = setTimeout(() => { t.classList.remove('is-visible'); setTimeout(() => { t.hidden = true; }, 300); }, 3800);
  };
  const setLoading = (btn, on) => {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  /* ---------- koszyk ---------- */
  const restoreTerms = () => {
    let v = '';
    try { v = sessionStorage.getItem('iskra-terms') || ''; } catch (e) { /* brak */ }
    $$('[data-terms-check]').forEach(cb => { cb.checked = v === '1'; });
  };
  const Cart = T.cart = {
    ids() { return Array.from(new Set($$('[data-cart-section]').map(el => el.dataset.cartSection).filter(Boolean))); },
    async request(url, body) {
      const ids = this.ids();
      if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      let data = {};
      try { data = await res.json(); } catch (e) { /* pusta odpowiedź */ }
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      if (data.sections) this.render(data.sections);
      document.dispatchEvent(new CustomEvent('cart:change', { detail: data }));
      return data;
    },
    add(items) { return this.request(T.routes.cartAdd + '.js', { items }); },
    change(id, quantity) { return this.request(T.routes.cartChange + '.js', { id, quantity }); },
    update(body) { return this.request(T.routes.cartUpdate + '.js', body); },
    async refresh() {
      const ids = this.ids();
      if (!ids.length) return;
      try { const res = await fetch(`${T.routes.cart}?sections=${ids.join(',')}`); this.render(await res.json()); } catch (e) { /* cicho */ }
    },
    render(sections) {
      Object.keys(sections || {}).forEach(id => {
        const html = sections[id];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(`[data-cart-section="${id}"]`);
        if (fresh) {
          $$(`[data-cart-section="${id}"]`).forEach(target => {
            const scroller = $('[data-cart-scroll]', target);
            const top = scroller ? scroller.scrollTop : 0;
            const hadFocus = target.contains(document.activeElement);
            target.innerHTML = fresh.innerHTML;
            const s2 = $('[data-cart-scroll]', target);
            if (s2) s2.scrollTop = top;
            if (hadFocus) { const p = target.closest('.drawer__panel') || target; p.setAttribute('tabindex', '-1'); p.focus({ preventScroll: true }); }
          });
        }
        const count = doc.querySelector('[data-cart-count-value]');
        if (count) this.setCount(count.dataset.cartCountValue);
      });
      restoreTerms();
    },
    setCount(n) { $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = Number(n) === 0; }); }
  };
  const afterAdd = () => {
    const open = $('dialog[open]');
    if (open) open.close();
    const drawer = $('cart-drawer');
    if (T.cartType === 'drawer' && drawer) drawer.open();
    else location.href = T.routes.cart;
  };
  T.afterAdd = afterAdd;
  document.addEventListener('cart:refresh', () => Cart.refresh());

  /* ---------- szuflady ---------- */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  class SideDrawer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.addEventListener('click', e => { if (e.target.closest('[data-close]')) { e.preventDefault(); this.close(); } });
      this.addEventListener('keydown', e => {
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key !== 'Tab' || !this.classList.contains('is-open')) return;
        const panel = $('.drawer__panel', this);
        const els = $$(FOCUSABLE, panel).filter(el => el.offsetParent !== null);
        if (!els.length) return;
        const first = els[0];
        const last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    open(trigger) {
      if (this.classList.contains('is-open')) return;
      this.trigger = trigger || document.activeElement;
      $$('.drawer.is-open').forEach(d => { if (d !== this && d.close) d.close(true); });
      this.classList.add('is-open');
      const panel = $('.drawer__panel', this);
      setTimeout(() => { const f = $('input[type="search"]', panel) || panel; if (f) f.focus({ preventScroll: true }); }, 60);
      this.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
    }
    close(silent) {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      if (!silent && this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true });
    }
  }
  define('side-drawer', SideDrawer);
  define('cart-drawer', class extends SideDrawer {});

  /* ---------- nagłówek ---------- */
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.header-wrapper') || this.parentElement;
      const setH = () => document.documentElement.style.setProperty('--header-h', Math.round(this.getBoundingClientRect().height) + 'px');
      setH();
      if (window.ResizeObserver) new ResizeObserver(setH).observe(this);
      const mode = this.dataset.sticky;
      const top = this.dataset.schemeTop;
      const base = this.dataset.scheme;
      let last = window.scrollY;
      let ticking = false;
      const update = () => {
        const y = window.scrollY;
        if (top) {
          const atTop = y < 10;
          this.classList.toggle('is-transparent', atTop);
          this.classList.toggle(top, atTop);
          this.classList.toggle(base, !atTop);
        }
        if (mode === 'scroll-up') this.wrapper.classList.toggle('is-hidden', y > last && y > 240 && !this.querySelector('details[open]'));
        last = y;
        ticking = false;
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
      const hover = window.matchMedia('(hover: hover) and (min-width: 990px)');
      $$('details[data-hover-menu]', this).forEach(d => {
        const li = d.parentElement;
        li.addEventListener('mouseenter', () => { if (hover.matches) { this.closeMenus(d); d.open = true; } });
        li.addEventListener('mouseleave', () => { if (hover.matches) d.open = false; });
        d.addEventListener('toggle', () => { if (d.open) this.closeMenus(d); });
      });
      document.addEventListener('click', e => { if (!this.contains(e.target)) this.closeMenus(); });
      this.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const o = $('details[open]', this);
        if (o) { o.open = false; $('summary', o).focus(); }
      });
    }
    closeMenus(except) { $$('details[data-hover-menu][open]', this).forEach(x => { if (x !== except) x.open = false; }); }
  }
  define('site-header', SiteHeader);

  /* ---------- wyszukiwarka ---------- */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type="search"]', this);
      this.results = $('[data-ps-results]', this);
      this.cache = new Map();
      if (this.dataset.enabled !== 'true' || !this.input || !this.results) return;
      this.input.addEventListener('input', debounce(() => this.search(), 220));
      this.input.addEventListener('keydown', e => {
        if (e.key !== 'ArrowDown') return;
        const f = $('a', this.results);
        if (f) { e.preventDefault(); f.focus(); }
      });
    }
    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; return; }
      const url = `${T.routes.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,page,query&resources[limit]=6&resources[options][unavailable_products]=last`;
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      try {
        let html = this.cache.get(url);
        if (!html) { const r = await fetch(url, { signal: this.controller.signal }); html = await r.text(); this.cache.set(url, html); }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const c = doc.querySelector('[data-ps-content]');
        this.results.innerHTML = c ? c.innerHTML : '';
      } catch (e) { /* przerwane */ }
    }
  }
  define('predictive-search', PredictiveSearch);

  /* ---------- slider ---------- */
  class SliderComponent extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-slider-track]', this);
      if (!this.track || this._init) return;
      this._init = true;
      this.prev = $('[data-slider-prev]', this);
      this.next = $('[data-slider-next]', this);
      this.dotsEl = $('[data-slider-dots]', this);
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.update()); }, { passive: true });
      if (window.ResizeObserver) { this.ro = new ResizeObserver(() => this.build()); this.ro.observe(this.track); } else this.build();
      if (this.dataset.autoplay && !reduceMotion) {
        this.play();
        ['mouseenter', 'focusin', 'touchstart'].forEach(ev => this.addEventListener(ev, () => this.stop(), { passive: true }));
        this.addEventListener('mouseleave', () => this.play());
      }
    }
    disconnectedCallback() { if (this.ro) this.ro.disconnect(); this.stop(); }
    get items() { return Array.from(this.track.children).filter(el => el.offsetParent !== null); }
    build() {
      const items = this.items;
      if (!items.length) return;
      const w = items[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = w + gap;
      const per = Math.max(1, Math.round((this.track.clientWidth + gap) / step));
      this.m = { step, per, count: items.length };
      if (this.dotsEl) {
        const n = per >= items.length ? 0 : Math.ceil(items.length / per);
        if (this.dotsEl.childElementCount !== n) {
          this.dotsEl.innerHTML = Array.from({ length: n }, (_, i) => `<button type="button" class="slider__dot" aria-label="${i + 1} / ${n}"></button>`).join('');
          Array.from(this.dotsEl.children).forEach((b, i) => b.addEventListener('click', () => this.goTo(i)));
        }
      }
      this.toggleAttribute('data-static', items.length <= per);
      this.update();
    }
    goTo(page) { if (!this.m) return; this.track.scrollTo({ left: page * this.m.per * this.m.step, behavior: reduceMotion ? 'auto' : 'smooth' }); }
    go(dir) {
      if (!this.m) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      const x = this.track.scrollLeft;
      const loop = this.hasAttribute('data-loop');
      if (dir > 0 && x >= max) { if (loop) this.track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
      if (dir < 0 && x <= 2) { if (loop) this.track.scrollTo({ left: this.track.scrollWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
      this.track.scrollBy({ left: dir * this.m.per * this.m.step, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    update() {
      if (!this.m) return;
      const x = this.track.scrollLeft;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const n = this.dotsEl ? this.dotsEl.childElementCount : 0;
      let page = Math.round(x / (this.m.per * this.m.step));
      if (x >= max - 2) page = Math.max(0, n - 1);
      if (this.dotsEl) Array.from(this.dotsEl.children).forEach((d, i) => d.setAttribute('aria-current', i === page ? 'true' : 'false'));
      if (!this.hasAttribute('data-loop')) {
        if (this.prev) this.prev.disabled = x <= 2;
        if (this.next) this.next.disabled = x >= max - 2;
      }
    }
    play() { this.stop(); this.timer = setInterval(() => { if (!document.hidden) this.go(1); }, Number(this.dataset.autoplay) || 5000); }
    stop() { clearInterval(this.timer); }
    scrollToItem(item) { if (!item || !this.track.firstElementChild) return; this.stop(); this.track.scrollTo({ left: item.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'smooth' }); }
  }
  define('slider-component', SliderComponent);

  /* ---------- ilość ---------- */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = $('input', this);
      if (!this.input) return;
      this.addEventListener('click', e => {
        const b = e.target.closest('[data-step]');
        if (!b) return;
        const min = this.input.min === '' ? 1 : Number(this.input.min);
        const max = this.input.max === '' ? Infinity : Number(this.input.max);
        const v = Math.min(max, Math.max(min, (Number(this.input.value) || 0) + Number(b.dataset.step)));
        if (v !== Number(this.input.value)) { this.input.value = v; this.input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }
  }
  define('quantity-input', QuantityInput);

  /* ---------- czas sklepu ---------- */
  const offsetMinutes = o => {
    const m = String(o || '').match(/([+-])(\d{2}):?(\d{2})/);
    if (!m) return -new Date().getTimezoneOffset();
    const v = Number(m[2]) * 60 + Number(m[3]);
    return m[1] === '-' ? -v : v;
  };
  const parseShopDate = (str, off) => {
    const m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    return Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), m[4] ? Number(m[4]) : 23, m[5] ? Number(m[5]) : 59) - off * 60000;
  };
  const isWeekend = (ts, off) => { const d = new Date(ts + off * 60000).getUTCDay(); return d === 0 || d === 6; };
  const nextCutoff = (hour, off) => {
    const now = Date.now();
    const local = new Date(now + off * 60000);
    let target = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), hour, 0) - off * 60000;
    let today = true;
    while (target <= now || isWeekend(target, off)) { target += 864e5; today = false; }
    return { target, today };
  };
  const pad = n => String(n).padStart(2, '0');

  class CountDown extends HTMLElement {
    connectedCallback() { this.init(); }
    disconnectedCallback() { clearInterval(this.timer); }
    init() {
      clearInterval(this.timer);
      this.off = offsetMinutes(this.dataset.offset);
      this.timeEl = $('[data-time]', this);
      if (this.dataset.mode === 'daily') {
        const r = nextCutoff(Number(this.dataset.hour || 14), this.off);
        this.end = r.target;
        const today = $('[data-today]', this);
        const late = $('[data-late]', this);
        if (late) { late.hidden = r.today; if (today) today.hidden = !r.today; }
      } else {
        this.end = parseShopDate(this.dataset.end, this.off);
      }
      if (!this.end || !this.timeEl) { this.expire(); return; }
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    tick() {
      const ms = this.end - Date.now();
      if (ms <= 0) { if (this.dataset.mode === 'daily') this.init(); else this.expire(); return; }
      this.hidden = false;
      const s = Math.floor(ms / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sec = s % 60;
      if (this.classList.contains('countdown--inline')) {
        this.timeEl.textContent = (d ? d + (T.strings.daysShort || 'd') + ' ' : '') + `${pad(h)}:${pad(m)}:${pad(sec)}`;
      } else {
        const parts = [[h, T.strings.hours], [m, T.strings.minutes], [sec, T.strings.seconds]];
        if (d) parts.unshift([d, T.strings.days]);
        this.timeEl.innerHTML = parts.map(([v, l]) => `<span class="countdown__unit"><b>${pad(v)}</b><small>${esc(l || '')}</small></span>`).join('');
      }
    }
    expire() {
      clearInterval(this.timer);
      if (this.dataset.expired === 'zero' && this.timeEl) { this.hidden = false; this.timeEl.textContent = '00:00:00'; return; }
      this.hidden = true;
      const box = this.closest('[data-countdown-box]');
      if (box) box.classList.add('is-ended');
      if (this.dataset.hideTarget && !designMode()) { const t = document.querySelector(this.dataset.hideTarget); if (t) t.hidden = true; }
    }
  }
  define('count-down', CountDown);

  class DeadlineBanner extends HTMLElement {
    connectedCallback() {
      const off = offsetMinutes(this.dataset.offset);
      const end = parseShopDate(this.dataset.end, off);
      const from = this.dataset.from && this.dataset.from.trim() ? parseShopDate(this.dataset.from.trim() + ' 00:00', off) : null;
      const now = Date.now();
      if (end) {
        const label = new Intl.DateTimeFormat(T.locale || undefined, { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(end + off * 60000));
        $$('[data-fmt-date]', this).forEach(el => { el.textContent = label; });
      }
      if (!end) { this.hidden = !designMode(); return; }
      if (from && now < from && !designMode()) { this.hidden = true; return; }
      const ended = now >= end;
      this.classList.toggle('is-ended', ended);
      if (ended && this.dataset.after === 'hide' && !designMode()) {
        const sec = this.closest('.shopify-section');
        if (sec) sec.hidden = true;
        return;
      }
      this.hidden = false;
    }
  }
  define('deadline-banner', DeadlineBanner);

  class DeliveryDate extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      const off = offsetMinutes(d.offset);
      const skip = d.skip === 'true';
      const local = new Date(Date.now() + off * 60000);
      const start = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate());
      const we = t => { const w = new Date(t).getUTCDay(); return w === 0 || w === 6; };
      const addDays = (t, n) => { let x = t; let left = n; while (left > 0) { x += 864e5; if (!skip || !we(x)) left -= 1; } return x; };
      let base = start;
      if (local.getUTCHours() >= Number(d.cutoff || 24) || (skip && we(base))) base = addDays(base, 1);
      const ship = addDays(base, Number(d.ship || 0));
      const from = addDays(ship, Number(d.min || 0));
      const to = addDays(ship, Math.max(Number(d.max || 0), Number(d.min || 0)));
      const fmt = (t, month) => new Intl.DateTimeFormat(T.locale || undefined, { day: 'numeric', month, timeZone: 'UTC' }).format(new Date(t));
      const set = (key, val) => { const el = $(`[data-date="${key}"]`, this); if (el) el.textContent = val; };
      set('order', fmt(start, 'short'));
      set('ship', fmt(ship, 'short'));
      set('deliver', from === to ? fmt(to, 'short') : `${fmt(from, 'short')} – ${fmt(to, 'short')}`);
      const text = $('[data-delivery-text]', this);
      if (text) text.innerHTML = (text.dataset.template || '').replace('[start]', fmt(from, 'long')).replace('[end]', fmt(to, 'long'));
    }
  }
  define('delivery-date', DeliveryDate);

  /* ---------- rekomendacje ---------- */
  const recCache = new Map();
  class CartRecs extends HTMLElement {
    async connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      let html = recCache.get(url);
      if (!html) {
        try { html = await (await fetch(url)).text(); recCache.set(url, html); } catch (e) { return; }
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const list = doc.querySelector('[data-recs]');
      if (!list || !this.isConnected) return;
      const exclude = (this.dataset.exclude || '').split(',');
      $$('[data-pid]', list).forEach(el => { if (exclude.indexOf(el.dataset.pid) > -1) el.remove(); });
      const items = Array.from(list.children).slice(0, 6);
      if (!items.length) return;
      this.innerHTML = `<p class="cart-upsell__title">${esc(this.dataset.title || '')}</p><div class="cart-upsell__list"></div>`;
      this.lastElementChild.append(...items);
    }
  }
  define('cart-recs', CartRecs);

  class ProductRecs extends HTMLElement {
    async connectedCallback() {
      if (this._loaded || !this.dataset.url || this.querySelector('[data-slider-track]')) return;
      this._loaded = true;
      try {
        const html = await (await fetch(this.dataset.url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('product-recs');
        if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
      } catch (e) { /* brak poleceń */ }
    }
  }
  define('product-recs', ProductRecs);

  /* ---------- popup ---------- */
  class PromoPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = $('dialog', this);
      if (!this.dialog) return;
      this.key = 'iskra-popup-' + this.dataset.id;
      this.dialog.addEventListener('close', () => store.set(this.key, String(Date.now())));
      if (this.querySelector('[data-popup-posted]')) { this.show(true); return; }
      if (this.dataset.enabled !== 'true' || designMode()) return;
      const last = Number(store.get(this.key) || 0);
      if (Date.now() - last < Number(this.dataset.days || 7) * 864e5) return;
      this.timer = setTimeout(() => this.show(), Number(this.dataset.delay || 8) * 1000);
      if (this.dataset.exit === 'true' && window.matchMedia('(hover: hover)').matches) {
        this.exit = e => { if (e.clientY <= 0 && !e.relatedTarget) this.show(); };
        document.addEventListener('mouseout', this.exit);
      }
    }
    show(force) {
      clearTimeout(this.timer);
      if (this.exit) document.removeEventListener('mouseout', this.exit);
      if (!this.dialog || this.dialog.open) return;
      if (!force && document.querySelector('dialog[open], .drawer.is-open')) return;
      this.dialog.showModal();
    }
  }
  define('promo-popup', PromoPopup);

  /* ---------- zakładki ---------- */
  class TabGroup extends HTMLElement {
    connectedCallback() {
      this.tabs = $$('[role="tab"]', this);
      this.tabs.forEach((t, i) => {
        t.tabIndex = i === 0 ? 0 : -1;
        t.addEventListener('click', () => this.select(i));
        t.addEventListener('keydown', e => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(n);
          this.tabs[n].focus();
        });
      });
    }
    select(i) {
      this.tabs.forEach((t, j) => {
        t.setAttribute('aria-selected', i === j ? 'true' : 'false');
        t.tabIndex = i === j ? 0 : -1;
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = i !== j;
      });
    }
  }
  define('tab-group', TabGroup);

  /* ---------- przed / po ---------- */
  class BeforeAfter extends HTMLElement {
    connectedCallback() {
      const r = $('.ba__range', this);
      if (r) r.addEventListener('input', () => this.style.setProperty('--pos', r.value + '%'));
    }
  }
  define('before-after', BeforeAfter);

  /* ---------- wideo ---------- */
  class VideoEmbed extends HTMLElement {
    connectedCallback() { this.addEventListener('click', () => this.play(), { once: true }); }
    play() {
      const { host, id } = this.dataset;
      let src = '';
      if (host === 'youtube') src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&playsinline=1`;
      else if (host === 'vimeo') src = `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1`;
      if (!src) return;
      this.innerHTML = `<iframe src="${src}" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen title="Video"></iframe>`;
    }
  }
  define('video-embed', VideoEmbed);

  class UgcVideo extends HTMLElement {
    connectedCallback() {
      this.video = $('video', this);
      if (!this.video) return;
      this.video.muted = true;
      this.video.playsInline = true;
      if (this.dataset.autoplay === 'true' && !reduceMotion && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(([e]) => {
          if (e.isIntersecting) { this.video.preload = 'auto'; this.video.play().catch(() => {}); }
          else this.video.pause();
        }, { threshold: 0.4 });
        this.io.observe(this);
      }
      this.addEventListener('click', e => { e.preventDefault(); this.toggleSound(); });
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    toggleSound() {
      const willUnmute = this.video.muted || this.video.paused;
      $$('ugc-video').forEach(u => { if (u !== this && u.video) { u.video.muted = true; u.classList.remove('is-unmuted'); } });
      this.video.muted = !willUnmute;
      if (willUnmute) this.video.play().catch(() => {});
      this.classList.toggle('is-unmuted', willUnmute);
    }
  }
  define('ugc-video', UgcVideo);

  const openStory = btn => {
    const sec = btn.closest('.shopify-section') || document;
    const tpl = document.getElementById('Story-' + btn.dataset.story);
    const dlg = $('.story-modal', sec);
    if (!tpl || !dlg) return;
    const body = $('[data-story-body]', dlg);
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    dlg.showModal();
    const v = $('video', body);
    if (v) v.play().catch(() => {});
    dlg.addEventListener('close', () => { body.innerHTML = ''; }, { once: true });
  };

  /* ---------- liczby ---------- */
  class CountUp extends HTMLElement {
    connectedCallback() {
      const txt = this.textContent.trim();
      const m = txt.match(/^(\D*?)(\d{1,3}(?:[ .\u00a0]\d{3})+|\d+)(\D*)$/);
      if (!m || reduceMotion || !('IntersectionObserver' in window)) return;
      const sepMatch = m[2].match(/\d([ .\u00a0])\d{3}/);
      const sep = sepMatch ? sepMatch[1] : '';
      const target = Number(m[2].replace(/[ .\u00a0]/g, ''));
      if (!isFinite(target) || target < 10) return;
      const fmt = v => String(v).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      if (this.getBoundingClientRect().top > window.innerHeight) this.textContent = m[1] + '0' + m[3];
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        const t0 = performance.now();
        const dur = 1400;
        const step = t => {
          const k = Math.min(1, (t - t0) / dur);
          this.textContent = m[1] + fmt(Math.round(target * (1 - Math.pow(1 - k, 3)))) + m[3];
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }, { threshold: 0.3 });
      io.observe(this);
    }
  }
  define('count-up', CountUp);

  /* ---------- udostępnianie i kody ---------- */
  class ShareButton extends HTMLElement {
    connectedCallback() {
      const btn = $('[data-share]', this);
      if (!btn) return;
      btn.addEventListener('click', async () => {
        const url = this.dataset.url;
        if (navigator.share) { try { await navigator.share({ url, title: this.dataset.title }); } catch (e) { /* anulowano */ } return; }
        try {
          await navigator.clipboard.writeText(url);
          const d = $('[data-share-done]', this);
          if (d) { d.hidden = false; setTimeout(() => { d.hidden = true; }, 2500); }
        } catch (e) { /* brak schowka */ }
      });
    }
  }
  define('share-button', ShareButton);

  class DiscountCode extends HTMLElement {
    connectedCallback() {
      const btn = $('button', this);
      if (!btn) return;
      btn.addEventListener('click', async () => {
        const code = this.dataset.code;
        try { await navigator.clipboard.writeText(code); } catch (e) { /* brak schowka */ }
        if (this.dataset.apply === 'true') {
          try { await fetch(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart.js')}`); } catch (e) { /* offline */ }
        }
        const l = $('[data-dcode-label]', this);
        if (l && l.dataset.done) l.textContent = l.dataset.done;
        this.classList.add('is-done');
      });
    }
  }
  define('discount-code', DiscountCode);

  /* ---------- zestaw ---------- */
  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', e => {
        if (e.target.matches('[data-bundle-variant]')) {
          const opt = e.target.selectedOptions[0];
          const cb = $('[data-bundle-item]', e.target.closest('.bundle__item'));
          if (cb && opt) { cb.value = e.target.value; cb.dataset.price = opt.dataset.price; cb.dataset.compare = opt.dataset.compare; }
        }
        if (e.target.matches('[data-bundle-item]')) e.target.closest('.bundle__item').classList.toggle('is-off', !e.target.checked);
        this.update();
      });
      const add = $('[data-bundle-add]', this);
      if (add) add.addEventListener('click', () => this.add(add));
      this.update();
    }
    get chosen() { return $$('[data-bundle-item]', this).filter(cb => cb.checked); }
    update() {
      const items = this.chosen;
      const d = items.length > 1 ? Number(this.dataset.discount || 0) : 0;
      const sum = items.reduce((a, cb) => a + Number(cb.dataset.price || 0), 0);
      const was = items.reduce((a, cb) => a + Number(cb.dataset.compare || 0), 0);
      const total = Math.round((sum * (100 - d)) / 100);
      const t = $('[data-bundle-total]', this);
      const w = $('[data-bundle-was]', this);
      const btn = $('[data-bundle-add]', this);
      if (t) t.textContent = T.formatMoney(total);
      if (w) w.textContent = was > total ? T.formatMoney(was) : '';
      if (btn) btn.disabled = !items.length;
    }
    async add(btn) {
      const err = $('[data-bundle-error]', this);
      if (err) err.hidden = true;
      setLoading(btn, true);
      try { await Cart.add(this.chosen.map(cb => ({ id: Number(cb.value), quantity: 1 }))); afterAdd(); }
      catch (e) { if (err) { err.textContent = e.message; err.hidden = false; } }
      finally { setLoading(btn, false); }
    }
  }
  define('bundle-builder', BundleBuilder);

  /* ---------- filtry kolekcji ---------- */
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.formId = 'FacetsForm-' + this.sectionId;
      const later = debounce(() => this.submit(), 500);
      this.onChange = e => {
        const el = e.target;
        if (!el.form || el.form.id !== this.formId) return;
        if (el.type === 'number') later(); else this.submit();
      };
      this.onPop = () => this.load(location.search.slice(1), false);
      document.addEventListener('change', this.onChange);
      window.addEventListener('popstate', this.onPop);
      this.addEventListener('click', e => {
        const a = e.target.closest('[data-facet-link]');
        if (!a) return;
        e.preventDefault();
        this.load(new URL(a.href, location.origin).search.slice(1));
      });
      this.addEventListener('submit', e => { if (e.target.id === this.formId) { e.preventDefault(); this.submit(); } });
    }
    disconnectedCallback() { document.removeEventListener('change', this.onChange); window.removeEventListener('popstate', this.onPop); }
    params() {
      const form = document.getElementById(this.formId);
      const p = new URLSearchParams();
      if (form) new FormData(form).forEach((v, k) => { if (String(v) !== '') p.append(k, v); });
      return p.toString();
    }
    submit() { this.load(this.params()); }
    async load(qs, push = true) {
      const results = $('[data-facets-results]', this);
      if (results) results.classList.add('is-loading');
      const url = `${location.pathname}?${qs}${qs ? '&' : ''}section_id=${this.sectionId}`;
      try {
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('facet-filters');
        if (!fresh) throw new Error('no-section');
        const form = document.getElementById(this.formId);
        const open = new Set($$('details.facet[open]', this).map(d => d.dataset.facet));
        ['[data-facets-results]', '[data-facets-bar]'].forEach(sel => { const a = $(sel, this); const b = $(sel, fresh); if (a && b) a.replaceWith(b); });
        const freshForm = fresh.querySelector('[data-facets-form]');
        if (form && freshForm) {
          form.innerHTML = freshForm.innerHTML;
          $$('details.facet', form).forEach(d => { d.open = open.has(d.dataset.facet); });
        }
        if (push) history.pushState(null, '', `${location.pathname}${qs ? '?' + qs : ''}`);
      } catch (e) {
        location.href = `${location.pathname}${qs ? '?' + qs : ''}`;
      }
    }
  }
  define('facet-filters', FacetFilters);

  /* ---------- szybkie dodawanie ---------- */
  const openQuick = async url => {
    const base = url.split('?')[0];
    const res = await fetch(base + '.js');
    if (!res.ok) throw new Error('quick');
    const p = await res.json();
    const dialog = document.getElementById('QuickAdd');
    const body = dialog && $('[data-quick-body]', dialog);
    if (!body) { location.href = url; return; }
    const opts = (p.options || []).map((o, i) => (typeof o === 'string'
      ? { name: o, values: Array.from(new Set(p.variants.map(v => v.options[i]))) }
      : { name: o.name, values: o.values }));
    let v = p.variants.find(x => x.available) || p.variants[0];
    body.innerHTML = `<div class="qv">
      <div class="qv__media ratio ratio--square"><img src="" alt="" data-qv-img></div>
      <div class="qv__info">
        <h2 class="h3 qv__title">${esc(p.title)}</h2>
        <div class="price price--lg" data-qv-price></div>
        ${opts.map((o, i) => `<fieldset class="variant-group"><legend class="variant-group__label"><span>${esc(o.name)}</span></legend><div class="pills">${o.values.map((val, j) => `<input type="radio" class="pill__input visually-hidden" id="qv-${i}-${j}" name="qv-${i}" value="${esc(val)}"${v.options[i] === val ? ' checked' : ''}><label for="qv-${i}-${j}" class="pill">${esc(val)}</label>`).join('')}</div></fieldset>`).join('')}
        <div class="qv__buy">
          <quantity-input class="qty"><button type="button" class="qty__btn" data-step="-1" aria-label="-">${ICON.minus}</button><input class="qty__input" type="number" inputmode="numeric" value="1" min="1" aria-label="#" data-qv-qty><button type="button" class="qty__btn" data-step="1" aria-label="+">${ICON.plus}</button></quantity-input>
          <button type="button" class="btn btn--lg" data-qv-add><span data-qv-label></span><span class="spinner" aria-hidden="true"></span></button>
        </div>
        <p class="form-error" hidden data-qv-error></p>
        <a href="${esc(url)}" class="link-btn">${esc(T.strings.viewDetails || '')}</a>
      </div>
    </div>`;
    const update = () => {
      const sel = opts.map((o, i) => { const c = body.querySelector(`input[name="qv-${i}"]:checked`); return c ? c.value : null; });
      v = p.variants.find(x => x.options.every((o, i) => o === sel[i]));
      opts.forEach((o, i) => $$(`input[name="qv-${i}"]`, body).forEach(inp => {
        const ok = p.variants.some(x => x.available && x.options[i] === inp.value && x.options.every((oo, j) => j >= i || oo === sel[j]));
        const lbl = body.querySelector(`label[for="${inp.id}"]`);
        if (lbl) lbl.classList.toggle('is-unavailable', !ok);
      }));
      const pr = $('[data-qv-price]', body);
      const btn = $('[data-qv-add]', body);
      const lbl = $('[data-qv-label]', body);
      if (!v) { pr.innerHTML = ''; btn.disabled = true; lbl.textContent = T.strings.unavailable || ''; return; }
      const sale = v.compare_at_price > v.price;
      pr.className = 'price price--lg' + (sale ? ' is-sale' : '');
      pr.innerHTML = `<span class="price__now">${T.formatMoney(v.price)}</span>${sale ? `<s class="price__was">${T.formatMoney(v.compare_at_price)}</s><span class="price__save">-${Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price)}%</span>` : ''}`;
      btn.disabled = !v.available;
      lbl.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      const src = (v.featured_image && v.featured_image.src) || p.featured_image;
      const im = $('[data-qv-img]', body);
      if (src) im.src = sized(src, 900);
      im.alt = p.title;
    };
    body.onchange = e => { if (e.target.name && e.target.name.indexOf('qv-') === 0) update(); };
    $('[data-qv-add]', body).addEventListener('click', async e => {
      const btn = e.currentTarget;
      if (!v) return;
      const err = $('[data-qv-error]', body);
      err.hidden = true;
      setLoading(btn, true);
      try { await Cart.add([{ id: v.id, quantity: Math.max(1, Number($('[data-qv-qty]', body).value) || 1) }]); afterAdd(); }
      catch (er) { err.textContent = er.message; err.hidden = false; }
      finally { setLoading(btn, false); }
    });
    update();
    dialog.showModal();
  };

  /* ---------- obsługa kliknięć ---------- */
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.open);
      if (d && typeof d.open === 'function') { e.preventDefault(); d.open(opener); }
      return;
    }
    const mo = e.target.closest('[data-modal-open]');
    if (mo) {
      const dlg = document.getElementById(mo.dataset.modalOpen);
      if (dlg && !dlg.open) { e.preventDefault(); dlg.showModal(); }
      return;
    }
    const mc = e.target.closest('[data-modal-close]');
    if (mc) { const dlg = mc.closest('dialog'); if (dlg) dlg.close(); return; }
    if (e.target instanceof HTMLDialogElement && e.target.open) {
      const r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    const { url, variant, single } = btn.dataset;
    setLoading(btn, true);
    try {
      if (single === 'true' && variant) { await Cart.add([{ id: Number(variant), quantity: 1 }]); afterAdd(); }
      else await openQuick(url);
    } catch (err) {
      if (single === 'true') T.toast(err.message, true);
      else location.href = url;
    } finally { setLoading(btn, false); }
  });

  const lineTimers = {};
  const changeLine = async (key, qty) => {
    const line = document.querySelector(`[data-line="${CSS.escape(key)}"]`);
    if (line) line.classList.add('is-loading');
    try { await Cart.change(key, Math.max(0, qty)); }
    catch (err) { T.toast(err.message, true); Cart.refresh(); }
  };

  const applyDiscount = async (form, remove) => {
    if (!form) return;
    const existing = (form.dataset.codes || '').split(',').map(s => s.trim()).filter(Boolean);
    const input = form.querySelector('input[name="discount"]');
    const code = remove ? '' : (input ? input.value.trim() : '');
    if (!remove && !code) return;
    const codes = remove ? existing.filter(c => c !== remove) : Array.from(new Set(existing.concat(code)));
    const btn = form.querySelector('button');
    setLoading(btn, true);
    try {
      const data = await Cart.update({ discount: codes.join(',') });
      if (!('discount_codes' in data)) {
        if (code) location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(location.pathname)}`;
        return;
      }
      if (code) {
        const hit = (data.discount_codes || []).find(d => String(d.code).toLowerCase() === code.toLowerCase());
        if (!hit || !hit.applicable) $$('[data-discount-error]').forEach(el => { el.hidden = false; const d = el.closest('details'); if (d) d.open = true; });
      }
    } catch (err) { T.toast(err.message, true); }
    finally { setLoading(btn, false); }
  };

  document.addEventListener('click', e => {
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { changeLine(rm.dataset.lineRemove, 0); return; }
    const co = e.target.closest('[data-checkout]');
    if (co) {
      const scope = co.closest('.cart-summary') || document;
      const cb = $('[data-terms-check]', scope);
      if (cb && !cb.checked) {
        e.preventDefault();
        const er = $('[data-terms-error]', scope);
        if (er) er.hidden = false;
        const lbl = cb.closest('.cart-terms');
        if (lbl) { lbl.classList.remove('shake'); void lbl.offsetWidth; lbl.classList.add('shake'); }
      }
      return;
    }
    const dr = e.target.closest('[data-discount-remove]');
    if (dr) { const s = dr.closest('.cart-summary'); applyDiscount(s && s.querySelector('[data-discount-form]'), dr.dataset.discountRemove); return; }
    const cl = e.target.closest('[data-clamp-toggle]');
    if (cl) { const w = cl.closest('.pdesc'); const open = w.classList.toggle('is-open'); cl.textContent = open ? cl.dataset.less : cl.dataset.more; return; }
    const cp = e.target.closest('[data-copy]');
    if (cp) {
      if (navigator.clipboard) navigator.clipboard.writeText(cp.dataset.copy).catch(() => {});
      const sp = $('span', cp);
      if (sp && cp.dataset.done) sp.textContent = cp.dataset.done;
      return;
    }
    if (e.target.closest('[data-to-top]')) { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
    const st = e.target.closest('[data-story]');
    if (st) openStory(st);
  });

  document.addEventListener('change', e => {
    const input = e.target.closest('[data-line-input]');
    if (input) {
      const key = input.dataset.lineInput;
      clearTimeout(lineTimers[key]);
      lineTimers[key] = setTimeout(() => changeLine(key, Number(input.value)), 350);
      return;
    }
    if (e.target.matches('[data-upsell-variant]')) {
      const up = e.target.closest('.upsell');
      const cb = up && up.querySelector('[data-upsell]');
      if (cb) cb.value = e.target.value;
      return;
    }
    if (e.target.matches('[data-terms-check]')) {
      try { sessionStorage.setItem('iskra-terms', e.target.checked ? '1' : ''); } catch (er) { /* brak */ }
      const s = e.target.closest('.cart-summary');
      const err = s && s.querySelector('[data-terms-error]');
      if (err && e.target.checked) err.hidden = true;
      return;
    }
    if (e.target.matches('[data-autosubmit]') && e.target.form) e.target.form.submit();
  });

  const saveNote = debounce(value => {
    fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: value }) }).catch(() => {});
  }, 500);
  document.addEventListener('input', e => { if (e.target.matches('[data-cart-note]')) saveNote(e.target.value); });

  document.addEventListener('submit', async e => {
    const disc = e.target.closest('[data-discount-form]');
    if (disc) { e.preventDefault(); applyDiscount(disc); return; }
    const track = e.target.closest('[data-track-form]');
    if (track) {
      e.preventDefault();
      const field = track.querySelector('input');
      const num = field ? field.value.trim() : '';
      if (!num) return;
      const url = (track.dataset.template || '').replace('[number]', encodeURIComponent(num));
      if (track.dataset.newtab === 'true') window.open(url, '_blank', 'noopener'); else location.href = url;
      return;
    }
    const form = e.target;
    if (!form.matches || !form.matches('form[data-type="product-form"]')) return;
    e.preventDefault();
    if (!form.checkValidity()) { form.reportValidity(); return; }
    const btn = form.querySelector('[name="add"]');
    const errEl = form.querySelector('[data-form-error]');
    if (!btn || btn.disabled) return;
    if (errEl) errEl.hidden = true;
    const fd = new FormData(form);
    const main = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    const props = {};
    fd.forEach((v, k) => { const m = k.match(/^properties\[(.+)\]$/); if (m && String(v).trim() !== '') props[m[1]] = v; });
    if (Object.keys(props).length) main.properties = props;
    const sp = fd.get('selling_plan');
    if (sp) main.selling_plan = Number(sp);
    const items = [main];
    Array.from(form.elements).forEach(el => { if (el.matches('[data-upsell]') && el.checked) items.push({ id: Number(el.value), quantity: 1 }); });
    setLoading(btn, true);
    try { await Cart.add(items); afterAdd(); }
    catch (er) { if (errEl) { errEl.textContent = er.message; errEl.hidden = false; } else T.toast(er.message, true); }
    finally { setLoading(btn, false); }
  });

  document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(d => { if (d.close) d.close(); }); });

  /* ---------- widoczność, zwijany opis, do góry ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(en => {
    if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
  }), { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }) : null;
  const initView = (root = document) => {
    const reveal = document.documentElement.classList.contains('has-reveal') && !designMode();
    if (!reveal) $$('[data-reveal]', root).forEach(el => el.classList.add('is-in'));
    $$('[data-in-view]' + (reveal ? ', [data-reveal]' : ''), root).forEach(el => { if (io) io.observe(el); else el.classList.add('is-in'); });
  };
  const initClamp = (root = document) => $$('.pdesc.is-clamped', root).forEach(w => {
    const b = $('.pdesc__body', w);
    const t = $('[data-clamp-toggle]', w);
    if (b && t && b.scrollHeight <= b.clientHeight + 4) { t.hidden = true; w.classList.remove('is-clamped'); }
  });
  const toTop = $('[data-to-top]');
  if (toTop) window.addEventListener('scroll', () => { toTop.hidden = window.scrollY < 900; }, { passive: true });
  initView();
  initClamp();
  restoreTerms();

  /* ---------- edytor motywu ---------- */
  document.addEventListener('shopify:section:load', e => { initView(e.target); initClamp(e.target); });
  document.addEventListener('shopify:section:select', e => { const p = $('promo-popup', e.target); if (p && p.show) p.show(true); });
  document.addEventListener('shopify:section:deselect', e => { const d = $('promo-popup dialog[open]', e.target); if (d) d.close(); });
  document.addEventListener('shopify:block:select', e => {
    const s = e.target.closest('slider-component');
    if (s && s.scrollToItem) s.scrollToItem(e.target.closest('[data-slider-track] > *'));
    const tab = e.target.closest('[role="tab"]');
    if (tab) tab.click();
    const hs = e.target.closest('details.hotspot');
    if (hs) hs.open = true;
  });
})();
